import Splide from "@splidejs/splide";
import GLightbox from 'glightbox';

document.querySelectorAll(".touchit-post-slider-gallery").forEach((galleryEl, index) => {
    const splide = new Splide(galleryEl, {
      type: "loop",
      drag: true,
      snap: true,
      perPage: 1,
      arrows: true,
      flickPower: 200,
    });

    splide.mount();

    galleryEl.querySelectorAll(".splide__slide").forEach((slide) => {
      const link = slide.querySelector("a.glightbox");
      if (!link || slide.classList.contains("splide__slide--clone")) return;
      link.setAttribute("data-gallery", `gallery-${index}`);
    });
  });

	const _lightbox = GLightbox({
		selector: '.splide__slide>.glightbox',
		loop: true,
		openEffect: "fade",
		closeEffect: "fade",
		width: "90vw",
	});